import React from 'react';
import { Button, Spinner } from 'reactstrap';

// Comprehend brand green, applied inline (not a Bootstrap theme color). The
// label uses a slightly deeper green so it stays readable on the pale fill —
// the reactstrap `alert-success` we used before forced white text, which
// washed out against the light background.
const GREEN = '#1d9e75';
const LABEL = '#0f7a57';

const baseStyle = {
  backgroundColor: '#ecf9f1',
  border: '1px solid #a8ddc6',
  borderRadius: 10,
  boxShadow: '0 1px 3px rgba(17, 24, 39, 0.06)',
  color: LABEL,
  position: 'relative',
  zIndex: 1050,
};

const InstructionUpdateStatusStrip = ({
  status,
  kind,
  onUndo,
  compact = false,
  style = {},
}) => {
  const isTemplateOnly = kind === 'template';
  const wrapperStyle = {
    ...baseStyle,
    fontSize: compact ? 13 : 14,
    padding: compact ? '5px 10px' : '6px 12px',
    ...style,
  };

  if (status === 'updating') {
    return (
      <div className="d-inline-flex align-items-center" style={wrapperStyle}>
        <Spinner
          size="sm"
          className="mr-2 flex-shrink-0"
          style={{ color: GREEN }}
        />
        <span>
          {isTemplateOnly ? 'Updating your template…' : 'Updating your note…'}
        </span>
      </div>
    );
  }

  if (status === 'updated') {
    return (
      <div className="d-inline-flex align-items-center" style={wrapperStyle}>
        <i
          className="fa fa-check mr-2 flex-shrink-0"
          style={{ color: GREEN }}
          aria-hidden="true"
        />
        <span className="font-weight-bold">
          {isTemplateOnly ? 'Template updated' : 'Note updated'}
        </span>
        <Button
          type="button"
          color="link"
          size="sm"
          className="ml-3 p-0 font-weight-bold"
          style={{ color: GREEN, textDecoration: 'underline' }}
          onClick={onUndo}
        >
          Undo
        </Button>
      </div>
    );
  }

  return null;
};

export default InstructionUpdateStatusStrip;
